<template>
    <div class="BankDataEdit">
        <!--<Form @submit="enviar">
            <ValidationObserver ref="formModelo145">-->
                <div class="card mb-3">
                    <div class="body">   
                        <div class="row">
                            <div class="col-md-4 col-xs-12">                  
                                <span>{{ $t('codPaisIban') }}</span>                 
                                <select id="select-pais" v-model="bankData.codSwiftBic" class="form-control" >
                                    <option v-for="pais in paises" v-bind:key="pais.codPais" v-bind:value="pais.codPais" >{{ pais.nombrePais }}</option>
                                </select>  
                            </div>      
                        </div>
                        <div class="row">
                            <div class="col-md-4 col-xs-12">                  
                                <span>{{ $t('numCuenta') }}</span>                 
                                <input name="numCuenta" v-model="cc" class="form-control"/>    
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4 col-xs-12">              
                                <span>{{ $t('codSwift') }}</span>                 
                                <input name="codSwift" v-model="bankData.codSwiftBic" class="form-control"/>  
                            </div>
                        </div>                        
                    </div>
                </div> 
            <!--</ValidationObserver> -->  
            <div class="row clearfix">                            
                <div class="col-md-1 col-xs-12">
                    <a class="btn btn-primary waves-effect waves-light btn-submit btn-loading hidden-progress" @click.prevent="enviar()">{{ $t('enviar') }}</a>
                    <!--<mmButton :text="$t('enviar')" :click="enviar()" classe="btn btn-primary waves-effect waves-light btn-submit btn-loading hidden-progress"></mmButton>-->
                </div>
                <div class="col-md-3 col-xs-12">
                    <router-link to="/employee" class="btn btn-secondary waves-effect waves-light btn-submit-cancel">{{ $t('cancelar') }}
                    </router-link>
                </div>
            </div>
        <!--</Form>-->
        {{ paises }}
        <br>
        {{ bankData }}
    </div>
</template>
    
<style scoped>
#FotoUsuario {
    width: 170px;
}
</style>

<script>
import { bankService } from '@/api/bank';

export default {
    name: 'BankDataEdit',
    props: {
        bankDataProp: Object
    },
    components: {
    },
    data(){
        return {            
            bankData: this.bankDataProp,
            paises: {},
            notifBank: {},
            cc: ''
        }
    },
    async mounted () {
        this.paises = await bankService.getPaises();
        this.notifBank.codSwiftBic = this.bankData.codSwiftBic;
        this.notifBank.cc = this.bankData.cuenta;
    },
    methods: {
        enviar(){
        },
        cancel() {
            this.$router.push({
                name: 'empleado'
            });
        },
    }
}
</script>